module.exports = __webpack_public_path__ + "img/4.bb03234.png";